import React from "react";

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 sm:gap-4 mb-6 sm:mb-8">
      <div className="min-w-0">
        <h1 className="font-display text-2xl sm:text-3xl lg:text-4xl font-black tracking-tight">{title}</h1>
        {subtitle && <p className="text-[#94A3B8] mt-1.5 sm:mt-2 text-xs sm:text-sm md:text-base">{subtitle}</p>}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
}

export function StatCard({ label, value, hint, accent = false, icon: Icon }) {
  return (
    <div className={`glass p-4 sm:p-5 ${accent ? "neon-glow" : ""}`}>
      <div className="flex items-start justify-between gap-2">
        <div className="text-[10px] sm:text-xs uppercase tracking-[0.15em] sm:tracking-[0.2em] text-[#94A3B8] font-bold leading-tight">{label}</div>
        {Icon && <Icon size={16} className="text-[#00F0FF] flex-shrink-0" strokeWidth={1.6} />}
      </div>
      <div className="font-display text-xl sm:text-2xl lg:text-3xl font-black mt-2 sm:mt-3 break-all">{value}</div>
      {hint && <div className="text-[10px] sm:text-xs text-[#94A3B8] mt-1">{hint}</div>}
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    pending: "bg-yellow-500/15 text-yellow-300 border-yellow-500/30",
    approved: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
    rejected: "bg-red-500/15 text-red-300 border-red-500/30",
    completed: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
    credited: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
    active: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30",
    closed: "bg-slate-500/15 text-slate-300 border-slate-500/30",
    inactive: "bg-slate-500/15 text-slate-400 border-slate-500/30",
    withdrawing: "bg-amber-500/15 text-amber-300 border-amber-500/30",
    open: "bg-yellow-500/15 text-yellow-300 border-yellow-500/30",
    suspended: "bg-red-500/15 text-red-300 border-red-500/30",
  };
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold uppercase tracking-wider border ${map[status] || "bg-white/5 text-white/80 border-white/10"}`}>
      {status}
    </span>
  );
}

export const fmtUSD = (v) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 2 }).format(Number(v || 0));

export const fmtDate = (s) => {
  if (!s) return "—";
  const d = new Date(s);
  return d.toLocaleDateString("en-US", { day: "numeric", month: "short", year: "numeric" });
};
